__turbopack_context__.v({
  "DealDuration": "ClaimForm-module-scss-module__vw2oBq__DealDuration",
  "EmailInput": "ClaimForm-module-scss-module__vw2oBq__EmailInput",
  "Form": "ClaimForm-module-scss-module__vw2oBq__Form",
  "SubmitButton": "ClaimForm-module-scss-module__vw2oBq__SubmitButton",
});
